import ZContainer from '@/ZForms/parsers/entities/ZEntityContainer';


export default window.ZForms.registerClass('container.gantt_chart', class ZGanttChart extends ZContainer {

});
